import { Injectable } from '@angular/core';

import { filter, map } from 'rxjs';

import { CamBaseService, GraphEndpoint, HandleSimpleRequest } from '@camelot/server';
import { isNonNullable } from '@camelot/utils';

import { ColorSet, ColorSetCreationPayloadInput, ColorSetModifierPayloadInput, colorSetProps } from './dto/color-set';
import { CREATE_COLOR_SET, UPDATE_COLOR_SET } from './mutations';
import { GET_COLOR_SETS } from './queries';

const graphEndpoint: GraphEndpoint = {
  clientName: 'planningService',
  endpoint: 'planning',
};

@Injectable({
  providedIn: 'root',
})
export class CamColorSetsService extends CamBaseService {
  protected _graphEndpoint = graphEndpoint;
  public colorSets = new HandleSimpleRequest<ColorSet[]>();

  constructor() {
    super();
    super.registerRoutes({ graphEndpoint: graphEndpoint });
  }

  public fetchColorSets$() {
    return this.colorSets.fetch(
      this._graphService
        .fetchPagedQueryList<ColorSet>(
          GET_COLOR_SETS(
            '',
            `
            ${colorSetProps.get('id')}
            ${colorSetProps.get('backgroundColor')}
            ${colorSetProps.get('borderColor')}
            ${colorSetProps.get('textColor')}
          `,
            ''
          ),
          'colorSets',
          graphEndpoint.clientName
        )
        .pipe(
          filter(isNonNullable),
          map(data => data.items)
        )
    );
  }

  public createColorSet$(colorSet: ColorSetCreationPayloadInput) {
    return this._graphService.mutateBuilder<ColorSet>(CREATE_COLOR_SET(colorSet), graphEndpoint.clientName, [
      'colorSets',
    ]);
  }
  public updateColorSet$(colorSet: Partial<ColorSetModifierPayloadInput>) {
    return this._graphService.mutateBuilder<ColorSet>(UPDATE_COLOR_SET(colorSet), graphEndpoint.clientName, [
      'colorSets',
    ]);
  }
}
